module.exports = __webpack_public_path__ + "static/media/messageapp.aa1f207a.png";